var _path, _path2, _path3, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTeleAccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_7983_24243",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 33,
    height: 22
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 0H0V22H22V0Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2998 2.79307V10.6895L14.279 8.98145H19.207C20.3936 8.98145 21.3554 8.01956 21.3554 6.83302V2.79307C21.3554 1.60653 20.3936 0.644636 19.207 0.644636H13.4482C12.2617 0.644636 11.2998 1.60653 11.2998 2.79307Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_7983_24243)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_7983_24243",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 22,
    height: 22
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 6.48499e-05H21.9999V22H0V6.48499e-05Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_7983_24243)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.4212 16.0546L11.41 15.0658C11.9546 14.5212 12.8375 14.5212 13.3821 15.0658L15.6884 17.3721C16.2329 17.9167 16.2329 18.7996 15.6884 19.3442L14.6996 20.333L12.9586 21.2072C12.6967 21.3387 12.4 21.3844 12.1106 21.3377C11.8213 21.291 11.554 21.1543 11.3468 20.947L1.05295 10.6532C0.845714 10.446 0.709044 10.1787 0.662347 9.88938C0.61565 9.60004 0.661301 9.30335 0.792815 9.04143L1.66705 7.30047L2.65585 6.31164C3.20043 5.76705 4.08331 5.76705 4.62789 6.31164L6.93423 8.61798C7.47878 9.16256 7.47878 10.0454 6.93423 10.59L5.9454 11.5788",
    fill: "#818194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4212 16.0546L11.41 15.0658C11.9546 14.5212 12.8375 14.5212 13.3821 15.0658L15.6884 17.3721C16.2329 17.9167 16.2329 18.7996 15.6884 19.3442L14.6996 20.333L12.9586 21.2072C12.6967 21.3387 12.4 21.3844 12.1106 21.3377C11.8213 21.291 11.554 21.1543 11.3468 20.947L1.05295 10.6532C0.845714 10.446 0.709044 10.1787 0.662347 9.88938C0.61565 9.60004 0.661301 9.30335 0.792815 9.04143L1.66705 7.30047L2.65585 6.31164C3.20043 5.76705 4.08331 5.76705 4.62789 6.31164L6.93423 8.61798C7.47878 9.16256 7.47878 10.0454 6.93423 10.59L5.9454 11.5788",
    stroke: "#818194",
    strokeWidth: 1.17187,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2998 2.79307V10.6895L14.279 8.98145H19.207C20.3936 8.98145 21.3554 8.01956 21.3554 6.83302V2.79307C21.3554 1.60653 20.3936 0.644636 19.207 0.644636H13.4482C12.2617 0.644636 11.2998 1.60653 11.2998 2.79307Z",
    fill: "#818194"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeleAccess);
export default __webpack_public_path__ + "static/media/TeleAccess.7868e83a22a3978a3e19b79dcd3cb540.svg";
export { ForwardRef as ReactComponent };